import { z } from 'zod'

export const DefaultSchema = z.object({
    created_at: z.coerce.date().default(() => new Date()),
    updated_at: z.coerce.date().default(() => new Date()),
    deleted_at: z.optional(z.coerce.date())
})